import { Button, Input, Modal, notification, Rate } from 'antd'
import { isUndefined } from 'lodash-es'
import { FunctionComponent, useState } from 'react'
import { useInput } from 'react-hanger'
import { useUpdateEffect } from 'react-use'
import { useEditCollaborationRecordScoringMutation } from '@/api/workspace-api/directory-api'
import { ModalTitle } from '@/components/common/modal-title'
import { IrmModalWrapper } from '@/components/kol/irm/common/irm-modal-wrapper'
import { scoreValueScale } from '@/constants/irm/score-value-scale'
import textMaximumLength from '@/constants/text-maximum-length'
import { useIntl } from '@/i18n/hooks/use-intl'
import { Score } from '@/types/schema/directory/kol-management'
import logger from '@/utils/logger'

interface EditScoreModalProps {
  open: boolean
  toggleModal: VoidFunction
  score?: Score
}

const EditScoreModal: FunctionComponent<EditScoreModalProps> = ({
  open,
  toggleModal,
  score,
}) => {
  const { formatMessage } = useIntl()
  const input = useInput('')
  const [scoreValue, setScoreValue] = useState(0)
  const [editScore, { isLoading }] = useEditCollaborationRecordScoringMutation()

  const handleEdit = async (): Promise<void> => {
    if (isUndefined(score)) {
      return
    }

    if (scoreValue === 0) {
      notification.warning({
        message: formatMessage({ id: 'irm:notify_fill_in_the_rating' }),
        placement: 'bottomRight',
      })

      return
    }

    try {
      await editScore({
        id: score.ID,
        score: {
          comment: input.value,
          scoreValue: scoreValue * scoreValueScale,
        },
      }).unwrap()
      toggleModal()
    } catch (error) {
      logger.error(error)
    }
  }

  useUpdateEffect(() => {
    if (open && !isUndefined(score)) {
      input.setValue(score.Comment)
      setScoreValue(score.ScoreValue / scoreValueScale)
    }
  }, [open])

  return (
    <Modal
      centered
      destroyOnClose
      footer={null}
      open={open}
      onCancel={toggleModal}
    >
      <IrmModalWrapper>
        <ModalTitle>
          {formatMessage({ id: 'irm:lable_edit_comment' })}
        </ModalTitle>
        <Rate
          allowHalf
          value={scoreValue}
          onChange={(value): void => setScoreValue(value)}
        />
        <Input.TextArea
          maxLength={textMaximumLength.title}
          rows={4}
          value={input.value}
          onChange={input.onChange}
        />
        <Button loading={isLoading} type='primary' onClick={handleEdit}>
          {formatMessage({ id: 'general:submit_btn' })}
        </Button>
      </IrmModalWrapper>
    </Modal>
  )
}

export default EditScoreModal
